import React, { useState } from 'react';

const FacilityCard = ({ slide }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="flex-1 bg-white rounded-lg overflow-hidden shadow-lg border-2 border-gray-200 transition-all duration-300 ease-in-out">
      <div className="relative h-[400px]">
        {slide.image ? (
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div className={`w-full h-full bg-gray-200 items-center justify-center ${slide.image ? 'hidden' : 'flex'}`}>
          <div className="text-center text-gray-600">
            <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <h4 className="text-lg font-semibold">{slide.title}</h4>
          </div>
        </div>
      </div>
      
      {/* Slide Title with Expand Icon */}
      <div className="p-4 bg-gradient-to-r from-pink-500 to-pink-600 flex justify-between items-center">
        <h4 className="text-white text-lg font-semibold text-left">
          {slide.title}
        </h4>
        
        {/* Expand Icon with Popup */}
        <div 
          className="relative"
          onMouseEnter={() => setShowPopup(true)}
          onMouseLeave={() => setShowPopup(false)}
        >
          <button className="bg-white/20 hover:bg-white/30 text-white p-2 rounded transition-all duration-200">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
            </svg>
          </button>

          {/* Popup */}
          {showPopup && (
            <div className="absolute bottom-full right-0 mb-2 w-64 bg-gray-800 text-white rounded-lg shadow-xl z-50">
              <div className="p-4">
                <h3 className="font-bold text-lg mb-3">{slide.title}</h3>
                
                <div className="space-y-2">
                  <div className="flex justify-between items-center py-2 border-b border-gray-600">
                    <span>Established</span>
                    <span className="font-semibold">{slide.established}</span>
                  </div>
                  
                  <div className="flex justify-between items-center py-2 border-b border-gray-600">
                    <span>Number Of Machines</span>
                    <span className="font-semibold">{slide.machines}</span>
                  </div>
                  
                  <div className="flex justify-between items-center py-2">
                    <span>Location</span>
                    <span className="font-semibold">{slide.location}</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FacilityCard;
